module.exports = __webpack_public_path__ + "img/array-down-icon.17ede15b.svg";